import { ReactNode, forwardRef, useImperativeHandle, useState } from "react"
import View from "../Base/View"
import './index.scss'

export interface ModalRef {
    open: () => void,
    close: () => void,
}

export interface ModalProp {
    isModal?: boolean,
    padding?: number,
    background?: string,
    zIndex?: number,
    clickPannelToClose?: boolean,
    children?: ReactNode,
    className?: string,
    onVisibleChange?: (isOpen: boolean) => void
}

const Modal = forwardRef((prop: ModalProp, _ref) => {


    const [modalState, setModalState] = useState<number>(-1);
    const { isModal, padding, background, zIndex, clickPannelToClose } = prop

    const _close = function () {
        setModalState(0)
        setTimeout(function () {
            setModalState(-1)
        }, 200)
        if (prop.onVisibleChange) {
            prop.onVisibleChange(false)
        }
    }
    /**
     * 打开对话框
     */
    const _open = function () {
        setModalState(1)
        if (prop.onVisibleChange) {
            prop.onVisibleChange(true)
        }
    }


    useImperativeHandle(_ref, () => ({
        close: _close,
        open: _open
    }))


    return <View
        className={
            'modal modal-state-' +
            (modalState == 1 ? 'open ' : modalState == 0 ? 'close ' : 'init ') +
            (prop.className? prop.className : '') + 
            ' flex-conainer'
        }
        style={{
            zIndex: `${zIndex || 998}`,
        }}
        onClick={() => {
            if (!isModal) {
                _close()
            }
        }}
    >
        <View
            className={
                'modal-inner flex-grow modal-pannel-state-' +
                (modalState == 1 ? 'open' : modalState == 0 ? 'close' : 'init')
            }
            style={{
                padding: `${(padding || 30) / 40}rem`,
                background: `${background || '#ffffff'}`,
                zIndex: `${(zIndex || 998) + 1}`,
            }}
            onClick={() => {
                if (clickPannelToClose) {
                    _close()
                }
            }}
        >
            {prop.children}
        </View>
    </View>
})

export default Modal